module.exports = __webpack_public_path__ + "Roboto-Bold.woff?eb43b4c3b3b6cac224f76c0a524946a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Bold/Roboto-Bold.woff?v=2.137
// module id = 190
// module chunks = 7